<template>
  <div>
    <Card>
      <p slot="title"> List Nota Transaksi Mutasi </p>
      <Row type="flex" justify="space-between">
        <Col span="10">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Bank Account</Button>
              <Select
                v-model="bankAccountId"
                placeholder="Select"
                clearable
                filterable
                @on-change="updateFilter">
                  <Option
                      v-for="bankAccount in bankAccounts"
                      :value="bankAccount.id"
                      :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
              </Select>
          </ButtonGroup>
        </Col>

        <Col span="5">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Kode Nota</Button>
              <Input style="width: 100%;" v-model="filterNoteCode" @on-keyup="updateFilter"></Input>
          </ButtonGroup>
        </Col>
         <Col span="4">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Cabang</Button>
              <Select
                  v-model="searchSelectSubbranch"
                  placeholder="Branchcode">
                  <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                      {{ subbranch.subbranchname }}
                  </Option>
              </Select>
          </ButtonGroup>
        </Col>

        <Col span="3">
            <Button type="primary" icon="ios-search" @click="getTransactionNote" :disabled="!isSearchShow">
              <span>Cari</span>
            </Button>
        </Col>
      </Row>

      <br />

      <Row type="flex" justify="space-between">
        <Col span="10">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Tgl. Transaksi</Button>
              <Date-picker
                  v-model="filterTransactionDate"
                  placeholder="Select date range"
                  style="width: 100%;"
                  type="daterange"
                  format="yyyy-MM-dd"
                  @on-change="updateFilter">
              </Date-picker>
              <!-- <DatePicker
                v-model="filterTransactionDateMonth"
                type="month"
                placeholder="Select month"
                style="width: 100%"
                @on-change="updateFilter"
              ></DatePicker> -->
          </ButtonGroup>
        </Col>

        <Col span="10">
            <ButtonGroup class="custom-group-parent">
                <Button class="custom-group">Marking &nbsp;&nbsp;&nbsp;</Button>
                <Select
                    style="width: 100%;"
                    v-model="markingIdSelected"
                    filterable
                    clearable
                    :remote-method="getMarkingByCode"
                    :loading="isLoadingMarking"
                    @on-change="updateFilter">
                    <Option v-for="option in optionMarkings"
                        :value="option.value" :key="option.value">{{option.label}}</Option>
                </Select>
            </ButtonGroup>
        </Col>

        <Col span="3">
            <Spin size="large" v-show="isLoadingMarking"></Spin>
        </Col>
      </Row>

      <br/>

      <!-- <Card>
        <cHotTransactionNotePayment v-if="transactionNoteData.length > 0"
            :dataHot="transactionNoteData">
        </cHotTransactionNotePayment>
      </Card> -->

      <Card>
          <Table :columns="columnsDataTable" :data="transactionNoteData" @on-selection-change="onSelectionChange"></Table>
      </Card>
    </Card>

    <div class="footer" v-show="transactionNotePrint.length > 0">
        <Button
            type="success"
            @click="notePrint(transactionNotePrint)"
            icon="printer"
            size="small"
            :loading="isPrinting">
                <span>Cetak {{ transactionNotePrint.length }} data</span>
        </Button>
        <!-- <Button
            type="error"
            @click="modalConfirmMultipleDelete = true"
            icon="trash-b"
            size="small"  >
                <span>Hapus {{ transactionNotePrint.length }} data</span>
        </Button> -->
    </div>

    <!-- table-sheet hidden -->
    <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    <!-- Modal Confirm Multiple Print -->
    <Modal v-model="modalConfirmMultiplePrint" width="50rem">
        <p slot="header" style="color:#19be6b;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Konfirmasi Cetak Data</span>
        </p>
        <div style="text-align:center; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));">
            <div v-for="data in transactionNotePrint">
                <Tag color="blue" style="width: 8rem;">{{ data.noteCode }}</Tag>
            </div>
        </div>
        <div slot="footer">
            <Button
                type="success" size="large" long icon="printer"
                :loading="isPrinting"
                @click="notePrint(transactionNotePrint)"
                >Cetak</Button>
        </div>
    </Modal>

    <!-- Modal Confirm Multiple Delete -->
    <Modal v-model="modalConfirmMultipleDelete" width="50rem">
        <p slot="header" style="color:#ed3f14;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Konfirmasi Hapus Data</span>
        </p>
        <div style="text-align:center; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));">
            <div v-for="data in transactionNotePrint">
                <Tag color="blue" style="width: 8rem;">{{ data.noteCode }}</Tag>
            </div>
        </div>
        <div slot="footer">
            <Button
                type="error" size="large" long icon="trash-b"
                :loading="isDelete"
                @click="noteDelete(transactionNotePrint)"
                >Hapus</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
// import cHotTransactionNotePayment from '@/components/payment/cHotTransactionNotePayment';

import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');

// handle -> ketika di wrap pada excel terlihat auto sumnya
// const formatter = new Intl.NumberFormat('id-ID', {
const formatter = new Intl.NumberFormat('en', {
  style: 'decimal',
  // minimumFractionDigits: 2,
  // maximumFractionDigits: 2,
});

// const formatted = formatter.format(1234567.89);
// console.log(formatted); // Output: "1.234.567,89"

export default {
    // components: {
    //   cHotTransactionNotePayment
    // },
    data () {
        return {
            bankAccounts: [],
            bankAccountId: null,
            filterTransactionDateMonth: '',
            filterTransactionDate: [],
            filterNoteCode: '',
            markingIdSelected: '',
            isSearchShow: false,
            optionMarkings: [],
            isLoadingMarking: false,
            searchSelectSubbranch: null,
            subbranchs: [],
            columnsDataTable: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: 'Kode Nota',
                    key: 'noteCode'
                },
                {
                    title: 'Tipe',
                    key: 'type'
                },
                {
                    title: 'Tgl. Transaksi',
                    key: 'transactionDate'
                },
                {
                    title: 'Tgl. Pembayaran',
                    key: 'paymentDate'
                },
                {
                    title: 'Mutasi',
                    key: 'amount'
                },
                {
                    title: 'Bank',
                    key: 'bankAccount'
                },
                {
                    title: 'Marking',
                    key: 'marking'
                }
            ],
            transactionNoteData: [],
            transactionNotePrint: [],
            modalConfirmMultiplePrint: false,
            modalConfirmMultipleDelete: false,
            isPrinting: false,
            isDelete: false,

            isAdministrator: localStorage.getItem('user.role') == 'ADMINISTRATOR' // ADMINISTRATOR only for check
        }
    },
    methods: {
        showDateFormatted : function(stringToFormat){
          let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
          return moment(dateToFormat).format("DD MMM YYYY")
        },
        totalAmountV1(transaction_note_details) {
          // Use reduce to sum the amount field
          return transaction_note_details.reduce((sum, detail) => {
            return sum + parseFloat(detail.payment[0].amount);
          }, 0);
        },
        totalAmount(paymentDetails) {
          // Use reduce to sum the amount field
          return paymentDetails.reduce((sum, detail) => {
            return sum + parseFloat(detail.amount);
          }, 0);
        },
        getBankAccount: function() {
          HTTP.get("bankAccount/findAll/active")
            .then(response => {
              this.bankAccounts = response.data;
            })
            .catch(e => {
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            });
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {
                        this.isLoadingMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.isLoadingMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),

        updateFilter: function() {
          let fBankAccount = this.bankAccountId;
          let fTrxDate = this.filterTransactionDate;
          let fNoteCode = this.filterNoteCode;
          let fMarkingSelected = this.markingIdSelected;
          let fTrxDateMonth = this.filterTransactionDateMonth;

          if(
            fNoteCode != ''
            || (fBankAccount != '' && fBankAccount != undefined)
            || (fTrxDate[0] != '' && fTrxDate[0] != null)
            || (fTrxDateMonth != '' && fTrxDateMonth != null)
            || (fMarkingSelected != '' && fMarkingSelected != undefined)
          ) {
            this.isSearchShow = true
          }else {
            this.isSearchShow = false
          }
        },

        getTransactionNote: function(){
            let fBankAccount = null;
            // bank akun -> mandatory
            if (this.bankAccountId != "" && this.bankAccountId != undefined) {
                fBankAccount = this.bankAccountId
            } else {
                this.$Notice.warning({
                    title: "Perhatian !",
                    desc: "Silahkan pilih bank akun terlebih dahulu",
                    duration: 5
                });

                return false
            }
            let fStartDate = null;
            let fEndDate = null;
            if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
                fStartDate = moment(this.filterTransactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                fEndDate = moment(this.filterTransactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            // Jika ada filter bulan, override start & end date
            if (this.filterTransactionDateMonth) {
              const monthDate = moment(this.filterTransactionDateMonth, 'YYYY-MM-DD');
              fStartDate = monthDate.startOf('month').format("YYYY-MM-DD");
              fEndDate = monthDate.endOf('month').format("YYYY-MM-DD");
            }
            let fNoteCode = this.filterNoteCode != "" ? this.filterNoteCode.toUpperCase() : null;
            let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

            let payload = {
                markingHeaderId: fMarkingSelected,
                paymentDateFrom: fStartDate,
                paymentDateTo: fEndDate,
                bankAccountId: fBankAccount,
                noteCode: fNoteCode,
                branchcode: this.searchSelectSubbranch
            }

            this.transactionNoteData = [];
            this.transactionNotePrint = [];
            this.$Loading.start();

            HTTP.post('transaction-note/list', payload)
            .then(response => {
                let parent = this;
                console.log({response});

                let transactionNoteDataTemp = [];

                _.forEach(response.data, function(value) {
                    let transactionDate = parent.showDateFormatted(value.transactionDate);
                    let paymentDate = value.paymentDate && value.paymentDate != '-' ? parent.showDateFormatted(value.paymentDate) : '-';
                    let bankAccount = value.bank_account ? value.bank_account.accountName : '-';
                    let amount = value.amount && value.amount != '-' ? numeral(parseFloat(value.amount)).format('0,0') : '-';;
                    let marking = value.markingHeaderId ? value.marking_header.markingheadercode : '-';
                    let isSpecialMarking = false;

                    if (value.markingGroupId) {
                        if(value.payment.length > 0) {
                            amount = numeral(parent.totalAmount(value.payment)).format('0,0');
                        }
                        marking = value.payment[0] ? value.payment[0].marking_header.markingheadercode : '-';

                        let prefixMarking = marking != '-' ? marking.split("/")[0] : '';
                        isSpecialMarking = prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH';

                        if (value.payment.length > 1) {
                            marking = '';

                            _.forEach(value.payment, function(itemPay) {
                                if (marking != itemPay.marking_header.markingheadercode) {
                                  marking += itemPay.marking_header.markingheadercode + ', ';
                                }
                            });

                            marking = marking.replace(/, $/, ''); // Menghapus ', ' di akhir teks
                        }
                    }

                    let trxNote = {
                        pending_id : value.id,
                        noteCode : value.noteCode,
                        transactionDate: transactionDate,
                        paymentDate: paymentDate,
                        bankAccount : bankAccount,
                        amount : (isSpecialMarking ? 'SGD ' : 'Rp. ') + amount,
                        marking : marking,
                        transactionNote : value,
                        type : value.ntType
                    }
                    transactionNoteDataTemp.push(trxNote);
                });

                parent.transactionNoteData = transactionNoteDataTemp;
                this.$Loading.finish();
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },

        onSelectionChange:function(selection){
          console.log({selection});
          this.transactionNotePrint = selection
        },

        showModalConfirmMultiplePrint: function(dataSelected){
          // cek -> apakah ada data yg belum melakukan pembayaran
          let isPaymentAll = true;

          dataSelected.forEach(item => {
              const paymentEmpty = item.paymentDate === '-';
              const markingEmpty = item.marking === '';

              if (paymentEmpty || markingEmpty) {
                  this.$Notice.error({
                      title: "Error",
                      desc: "Tidak dapat mencetak karena ada data yang belum melakukan pembayaran !",
                      duration: 5
                  });

                  isPaymentAll = false;
              }
          });

          this.modalConfirmMultiplePrint = isPaymentAll ? true : false;
        },

        notePrint(dataTrx) {
          console.log({dataTrx});
          this.isPrinting = true

          let pendingIds = dataTrx.map(item => item.pending_id)

          console.log({pendingIds});

          HTTP.post('transaction-note/get-detail', { pendingIds }, {
            responseType: 'blob'
          })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${dataTrx.length > 1 ? 'NT' : 'NT - ' + dataTrx[0].noteCode}` + ` - ${moment(new Date()).format("DDMMYYhhmmss")}.xls`); // name file downloaded
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.isPrinting = false;
          }).catch(e => {
            this.isPrinting = false;
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
        },

        noteDelete(dataTrx) {
          this.isDelete = true;

          HTTP.post('transaction-note/delete', {dataTrx})
            .then(response => {
                console.log({response});

                if (response.data) {
                  this.$Message.success('Nota transaksi berhasil dihapus !');
                  this.isDelete = false
                  this.transactionNotePrint = []
                  this.modalConfirmMultipleDelete = false
                  this.getTransactionNote();
                }
            })
            .catch(e => {
                this.isDelete = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        },
        getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
    },

    mounted() {
        this.$Loading.config({
            color: '#ffffff',
            failedColor: '#f0ad4e',
            height: 10
        });

        this.getBankAccount();
        this.getSubbranch();
        // this.getTransactionNote()
    }
}

</script>



// WEBPACK FOOTER //
// PaymentTransactionNote.vue?702f3487